import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=b8b0f934"
import script from "./CarInfo.vue?vue&type=script&lang=js"
export * from "./CarInfo.vue?vue&type=script&lang=js"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=b8b0f934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports